export default __webpack_public_path__ + "static/media/noyaxe.147b8e73.png";